import { styled } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

export const BoxStyled = styled(Box)({
  marginBottom: '24px',
});

export const TypographyStyled = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
  color: blue[700],
  cursor: 'pointer',
  fontSize: '14px',
});
